/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';

interface Props {
  button_text: string;
  button_id: string;
  button_class: string;
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
  data_button: string;
  event_value?: string;
}
const WaEventAltaOroButton: FC<Props> = (props) => {
  const {
    button_text,
    button_id,
    button_class,
    hittype,
    event_category,
    event_action,
    event_label,
    data_button,
    event_value,
  } = props;

  if (event_value) {
    return (
      <button
        id={button_id}
        type="submit"
        className={button_class}
        data-wa-hittype={hittype}
        data-wa-event-category={event_category}
        data-wa-event-action={event_action}
        data-wa-event-label={event_label}
        data-button={data_button}
        data-wa-event-value={event_value}
      >
        {button_text}
      </button>
    );
  }
  return (
    <button
      id={button_id}
      type="submit"
      className={button_class}
      data-wa-hittype={hittype}
      data-wa-event-category={event_category}
      data-wa-event-action={event_action}
      data-wa-event-label={event_label}
      data-button={data_button}
    >
      {button_text}
    </button>
  );
};
export default WaEventAltaOroButton;
